/**
 * constants for Connect Model
 * @type {Object}
 */
module.exports = {
    AUTH_TYPE_EMAIL: 'email',
    AUTH_TYPE_FB: 'facebook',
    AUTH_METHOD_EMAIL: 'email',
    AUTH_METHOD_FB: 'fb'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/constants/connect.js
// module id = 201
// module chunks = 0